import { useEffect, useLayoutEffect, useRef, useState } from 'react';

/**
 * Keeps a scroll container pinned to the bottom when new content arrives —
 * unless the user has scrolled up to read older entries. A callback ref: the
 * container may appear later (a chat opened on a phone) and starts at the bottom.
 */
export function useAutoScroll<T extends HTMLElement>(dep: unknown) {
  const [el, setEl] = useState<T | null>(null);
  const pinned = useRef(true);

  useEffect(() => {
    if (!el) return;
    pinned.current = true;
    const onScroll = () => {
      pinned.current = el.scrollHeight - el.scrollTop - el.clientHeight < 48;
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [el]);

  useLayoutEffect(() => {
    if (el && pinned.current) el.scrollTop = el.scrollHeight;
  }, [dep, el]);

  return setEl;
}
